import { COLORS, DEVICES, FONT_FAMILY } from '@Commons';
import styled from 'styled-components';

export const Description = styled.div`
  font-size: 16px;
  font-weight: 22px;
  font-family: ${FONT_FAMILY.hellix.regular};
  color: ${COLORS.textGrey};
  text-align: center;
  margin: 8px 0 48px;
  max-width: 450px;
  line-height: 22px;
`;

export const EditBeneInfoForm = styled.form`
  max-width: 450px;
  @media ${DEVICES.mobileXL} {
    width: 100%;
  }
`;

export const NameFieldsContainer = styled.div`
  .MuiFormControl-root {
    height: unset !important;
    width: 100%;
    max-width: 100%;
    margin: 0;
  }
  .Mui-error {
    width: 450px !important;
    margin-left: 0;
    @media ${DEVICES.mobileXL} {
      width: 100% !important;
    }
  }
`;

export const BeneIdentityHelperText = styled.div`
  margin-top: 14px;
  font-size: 14px;
  font-weight: 22px;
  font-family: ${FONT_FAMILY.hellix.regular};
`;

export const ButtonContainer = styled.div`
  margin-top: 48px; ;
`;

export const BankFieldsContainer = styled.div`
  margin-top: 25px;
`;
